import { FC } from 'react'

type Props = {
  color?: string
  className?: string
  fill?: string
}

const DeliveredStatus: FC<Props> = ({ className, color, fill }) => {
  return (
    <svg
      className={className}
      width="43"
      height="44"
      viewBox="0 0 43 44"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0505 36.68L24.3305 40.13L41.5305 30.85V10.2L24.3305 1L7.31055 10.2V26.2"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33 42.95C13.9305 42.95 17.66 39.2206 17.66 34.62C17.66 30.0195 13.9305 26.29 9.33 26.29C4.72947 26.29 1 30.0195 1 34.62C1 39.2206 4.72947 42.95 9.33 42.95Z"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.58984 34.62L8.44984 37.49L13.0598 31.75"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.31055 10.2001L24.3305 18.7401V40.1301"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.3301 18.7401L41.5301 10.2001"
        stroke={color || '#221F20'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5801 6.80999L30.2301 15.81V24.35L36.0801 21.38V12.91L18.8101 3.98999"
        stroke={color || '#221F20'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default DeliveredStatus
